import { render, staticRenderFns } from "./apis.vue?vue&type=template&id=05d3a0e8&"
import script from "./apis.vue?vue&type=script&lang=js&"
export * from "./apis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05d3a0e8')) {
      api.createRecord('05d3a0e8', component.options)
    } else {
      api.reload('05d3a0e8', component.options)
    }
    module.hot.accept("./apis.vue?vue&type=template&id=05d3a0e8&", function () {
      api.rerender('05d3a0e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/superAdmin/authority/components/apis.vue"
export default component.exports